import { Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/core/home/components/confirm-dialog/confirm-dialog.component';
import { OrdenID } from 'src/app/core/instalaciones/interfaces/OrdenId.interface';
import { Result } from 'src/app/core/instalaciones/interfaces/Ordenes';
import { ResultOrden } from 'src/app/core/instalaciones/interfaces/OrdenesInstalaciones.interface';
import { OrdenesInstalacionService } from 'src/app/core/instalaciones/services/ordenes-instalacion.service';
import { ReportOrderService } from 'src/app/core/instalaciones/services/report-order.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent {
  private ordenes = inject(OrdenesInstalacionService);
  private orderservice = inject(ReportOrderService);
  private clipboard = inject(Clipboard);
  private snack = inject(SnackbarService);
  private dialog = inject(MatDialog);
  constructor(public dialogRef: MatDialogRef<InfoComponent>,@Inject(MAT_DIALOG_DATA) public data: ResultOrden) {}
  orden!: OrdenID;
  ngOnInit(): void {
    this.getOrderID();
  }
  getOrderID() {
    this.ordenes.getOrderID(this.data.id).then((data) => {
      this.orden = data;
    });
  }
  copyToClipboard(value: string): void {
    this.clipboard.copy(value);
    this.snack.openSnackBar('¡Texto copiado al portapapeles!');
  }
  sendConfirmation(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message: `Enviar mensaje de confirmación a la Orden #${this.data.order}`,
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // this.confirmDisabled = id.toString();
        let body = {
          confirmar: this.data.order,
        };
        this.orderservice
          .postConfirmOrder(body)
          .then((result) => {
            // console.log(result, 'results')
            this.snack.openSnackBar('Enviado con exito!');
            this.getOrderID();
          })
          .catch((err) => {
            console.log(err, 'error');
            this.snack.openSnackBar(
              'Ups! Ocurrió un error, contacte con el Administrador'
            );
          });
      }
    });
  }
  addObservations(): void {
    // const dialogRef = this.dialog.open(DialogAddObservationsComponent, {
    //   data: this.orden,
    //   width: window.innerWidth > 696 ? '40%' : 'auto',
    // });
    // dialogRef.afterClosed().subscribe((confirmed: boolean) => {
    //   if (confirmed) {
    //     this.getOrderID();
    //   }
    // });
  }
}
